module.exports = __webpack_public_path__ + "img/mine-icon-no-gift.b6a3d9e1.png";